import PropTypes from "prop-types";
// material
import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

// ----------------------------------------------------------------------

FulfillmentBadge.propTypes = {
  fulfillmentType: PropTypes.string,
  isPickup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(["small", "medium"]),
  sx: PropTypes.object,
};

export default function FulfillmentBadge({
  fulfillmentType = "",
  isPickup = false,
  size = "small",
  sx = {},
}) {
  const theme = useTheme();
  const pickup =
    Boolean(isPickup === true || isPickup === 1 || isPickup === "1") ||
    (typeof fulfillmentType === "string" &&
      fulfillmentType.toLowerCase().includes("pickup"));

  const displayText =
    fulfillmentType || (pickup ? "Store Pick-up" : "Delivery");

  const isSmall = size === "small";

  const colorMain = pickup
    ? theme.palette.info.main
    : theme.palette.warning.dark;
  const bgColor = pickup
    ? alpha(theme.palette.info.main, 0.12)
    : alpha(theme.palette.warning.main, 0.14);
  const borderColor = pickup
    ? alpha(theme.palette.info.main, 0.35)
    : alpha(theme.palette.warning.main, 0.35);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "6px",
        px: isSmall ? 1 : 1.5,
        py: isSmall ? 0.4 : 0.6,
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      {pickup ? (
        <StorefrontIcon
          sx={{
            fontSize: isSmall ? 14 : 18,
            color: colorMain,
            mr: 0.6,
          }}
        />
      ) : (
        <LocalShippingOutlinedIcon
          sx={{
            fontSize: isSmall ? 14 : 18,
            color: colorMain,
            mr: 0.6,
          }}
        />
      )}
      <Typography
        variant={isSmall ? "caption" : "subtitle2"}
        sx={{
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          fontSize: isSmall ? "0.6875rem" : "0.75rem",
          color: colorMain,
          lineHeight: 1.2,
        }}
      >
        {displayText}
      </Typography>
    </Box>
  );
}
